export default __webpack_public_path__ + "static/media/left-arrow.b2f134a7.svg";